import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, delay, first, map, Observable, skip, Subject, switchMap, takeUntil, takeWhile, tap } from 'rxjs';
import { LgvAPIService, LgvClientService, LgvConstants, LgvUserService, NotificationService } from '../../core/core.module';
import { ObjectValidator } from '../../core/utility/lgv-form-validator';
import { RegexConstants, RegexValidator } from '../../core/utility/lgv-regex-validator';
import { LgvModel } from '../../data-models/longevity.model';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { environment as env } from '../../../environments/environment';

@Component({
  selector: 'lgv-edit-user-config-modal',
  templateUrl: './edit-user-config-modal.component.html',
  styleUrls: ['./edit-user-config-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditUserConfigModalComponent implements OnInit {

    @Output() OnOKClicked: EventEmitter<string> = new EventEmitter();

    entity: ConfigEntity;

    isLoading$ = new BehaviorSubject(false);
    entityForm: UntypedFormGroup;
    onDestroy$ = new Subject();

    agentInfoParam: LgvModel.Agent = null;
    lpApplicationUserParam: LgvModel.ApplicationUser = null;
    pricingApplicationCompanyParam: LgvModel.ApplicationCompany = null;

    public static floifyTokenKey = 'floify-user-token';

    /*
     * this modal was intended to be a generic modal to edit a single value for an agent / user.
     * edit EditPpeOriginationIDComponent came first, then the floify token.  Seems like there may be more to come, so I
     * made this one generic.  EditPpeOriginationIDComponent can merged into this one.  May not be worth the effort to unify, but that was the thought.
     */

    constructor(
        private http: HttpClient,
        private fb: UntypedFormBuilder,
        public notificationSvc: NotificationService,
        public lgvUserSvc: LgvUserService,
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        public MatDialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        if (!!(data?.entityKey)) {
            this.setEntity(data.entityKey);
        }
        if (!!(data?.entityValue && this.entity)) {
            this.entity.value = data.entityValue;
        }
        if (!!(data?.agentInfo)) {
            this.agentInfoParam = data.agentInfo;
        }
        if (!!(data?.pricingApplicationCompany)) {
            this.pricingApplicationCompanyParam = data.pricingApplicationCompany;
        }
        if (!!(data?.lpApplicationUser)) {
            this.lpApplicationUserParam = data.lpApplicationUser;
        }

    }

    ngOnInit(): void {
        this.lgvUserSvc.LoadUserRoles();
        this.initializeForm();
    }

    ngOnDestroy(): void {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    setEntity(key: string) {

        switch (key) {
            case EditUserConfigModalComponent.floifyTokenKey: {
                this.entity = {
                    name: 'Floify Token',
                    key: key,
                    label: 'Token'
                };
            }
            break;
        }

    }

    initializeForm() {
        this.entityForm = this.fb.group({
            entityValue: [this.entity.value, [Validators.required]]
        });
    }

    onCancel(): void {
        this.dialogRef.close({ action: false });
    }

    onSave() {
        if (this.entityForm.invalid) {
            return;
        }


        switch (this.entity.key) {
            case EditUserConfigModalComponent.floifyTokenKey: this.saveToken();
        }
    }

    saveToken() {
        let bldUrl = env.LgvApiBaseUrl;
        bldUrl += `/users/${this.agentInfoParam.id}/tokens`;

        let model = {
            name: this.entity.key,
            value: this.entityForm.get('entityValue').value
        }

        this.http.put<any>(bldUrl, model).pipe(takeUntil(this.onDestroy$)).subscribe(x => {
            console.log('response from save:');
            console.log(x);
            this.notificationSvc.success(`${this.entity.name} as been saved.`);
            this.dialogRef.close({ action: true });
        },
            err => {
                console.log(err);
                this.notificationSvc.error(`There was an error saving ${this.entity.name}`);
            });
    }
}

class ConfigEntity {
    key: string;
    name: string;
    label: string;
    value?: string;
}

